(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["custom-footer"] && !Shopify.designMode) return;
  try {
    
  // Footer Localization Dropup Functionality
  (function() {
    const footerLocalizations = document.querySelectorAll('.footer-localization');

    footerLocalizations.forEach(localization => {
      const button = localization.querySelector('.footer-localization__button');
      const list = localization.querySelector('.footer-localization__list');
      const form = localization.querySelector('.footer-localization__form');
      const hiddenInput = form?.querySelector('input[name="locale_code"], input[name="country_code"]');
      const options = localization.querySelectorAll('.footer-localization__option');

      if (!button || !list) return;

      // Toggle dropup on button click
      button.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();
        
        const isExpanded = button.getAttribute('aria-expanded') === 'true';
        
        // Close all other dropups first
        document.querySelectorAll('.footer-localization__button[aria-expanded="true"]').forEach(btn => {
          if (btn !== button) {
            btn.setAttribute('aria-expanded', 'false');
            const btnList = btn.closest('.footer-localization__disclosure')?.querySelector('.footer-localization__list');
            if (btnList) btnList.setAttribute('hidden', '');
          }
        });
        
        // Toggle current dropup
        button.setAttribute('aria-expanded', !isExpanded);
        if (isExpanded) {
          list.setAttribute('hidden', '');
        } else {
          list.removeAttribute('hidden');
        }
      });

      // Handle option selection
      options.forEach(option => {
        option.addEventListener('click', (e) => {
          e.preventDefault();
          const value = option.getAttribute('data-value');
          
          if (value && hiddenInput && form) {
            hiddenInput.value = value;
            form.submit();
          }
        });
      });
    });

    // Close dropups when clicking outside
    document.addEventListener('click', (e) => {
      if (!e.target.closest('.footer-localization')) {
        document.querySelectorAll('.footer-localization__button[aria-expanded="true"]').forEach(btn => {
          btn.setAttribute('aria-expanded', 'false');
          const list = btn.closest('.footer-localization__disclosure')?.querySelector('.footer-localization__list');
          if (list) list.setAttribute('hidden', '');
        });
      }
    });

    // Close on Escape key
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape') {
        document.querySelectorAll('.footer-localization__button[aria-expanded="true"]').forEach(btn => {
          btn.setAttribute('aria-expanded', 'false');
          const list = btn.closest('.footer-localization__disclosure')?.querySelector('.footer-localization__list');
          if (list) list.setAttribute('hidden', '');
          btn.focus();
        });
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["reels-video-section"] && !Shopify.designMode) return;
  try {
    
  function initAllReelsSections() {
    var sections = document.querySelectorAll('[data-reels-section-id]');

    sections.forEach(function (section) {
      if (section.dataset.reelsInit === 'true') return;

      var scroller = section.querySelector('.reel-video-list');
      var prevButton = section.querySelector('.reel-nav--prev');
      var nextButton = section.querySelector('.reel-nav--next');

      if (!scroller || !prevButton || !nextButton) return;

      var firstCard = scroller.querySelector('.reel-video-card');

      function getScrollAmount() {
        if (firstCard) {
          var rect = firstCard.getBoundingClientRect();
          var cardWidth = rect.width;
          var gap = 24; // matches CSS gap on desktop
          return cardWidth + gap;
        }
        return scroller.clientWidth || 0;
      }

      function scrollByAmount(direction) {
        var amount = getScrollAmount() * direction;
        var newLeft = scroller.scrollLeft + amount;
        if (typeof scroller.scrollTo === 'function') {
          scroller.scrollTo({ left: newLeft, behavior: 'smooth' });
        } else {
          scroller.scrollLeft = newLeft;
        }
      }

      prevButton.addEventListener('click', function () {
        scrollByAmount(-1);
      });

      nextButton.addEventListener('click', function () {
        scrollByAmount(1);
      });

      section.dataset.reelsInit = 'true';
    });
  }

  // Initialize immediately in case DOMContentLoaded has already fired
  initAllReelsSections();

  document.addEventListener('DOMContentLoaded', initAllReelsSections);
  document.addEventListener('shopify:section:load', initAllReelsSections);

  } catch(e) { console.error(e); }
})();
})();
